export const useUploadField = ({ slug, uploadLabels }) => {
	const stepsWithMessage = ['income_proof']

	const fieldLabel = slug?.front
	? 'Foto da Frente do documento'
	: uploadLabels?.field
	
	const fieldDescription = uploadLabels?.description
	? uploadLabels.description
	: ''
	
	const showMask = true


	const hasSimpleDescription = !!fieldDescription && !stepsWithMessage.includes(slug)
	const hasMessage 		   = !!fieldDescription && stepsWithMessage.includes(slug)

	return {
		fieldLabel,
		showMask,
		fieldDescription,
		hasSimpleDescription,
		hasMessage
	}
}